import { useEffect } from "react";

import { PricingContentContextProvider } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import {
    SoftwareRovoPricingPageTemplate,
    SoftwareRovoPricingPageTemplateProps
} from "@/templates/software/rovo/pricing/software-rovo-pricing-page/src";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content.ts";

export type SoftwareRovoPricingPageProps =
    SoftwareRovoPricingPageTemplateProps & {
        pricingContent?: PricingContent;
    };

export const SoftwareRovoPricingPage = (
    props: SoftwareRovoPricingPageProps
) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <div data-testid="rovo-pricing-page">
            <PricingContentContextProvider
                productId="rovo"
                pricingContent={props.pricingContent}
            >
                <SoftwareRovoPricingPageTemplate {...props} />
            </PricingContentContextProvider>
        </div>
    );
};
